import { ITask, ITaskSourceSystem } from '../models/task-models';
import { Task, TaskSourceSystem } from '../models/task-viewmodels';

import { isToday, isPast } from '@/shared/services/format-date-filter';
import DateTimeMapper from '@/shared/mappings/date-time-mapper';

/**
 * Mapper for the Task service
 */
export default class TaskMapper {
    public mapTaskSourceSystem(item: ITaskSourceSystem, language: string): TaskSourceSystem {
        return new TaskSourceSystem(
            item.sourceSystem,
            item.validResponse,
            item.responseMessage,
            item.tasks.map((task => this.mapTask(task, language)))
        );
    }

    public mapTask(item: ITask, language: string): Task {
        return new Task(
            item.type,
            item.dueDate ? DateTimeMapper.mapItem(item.dueDate, language) : '',
            item.dueDate ? DateTimeMapper.mapItem(item.dueDate, language, 'DD-MM-YYYY') : '',
            isToday(item.dueDate),
            isPast(item.dueDate),
            item.description,
            item.url
        );
    }
}